module.exports = __webpack_public_path__ + "img/king-dedede-min.633d338d.png";